<template>
  <div class="allActiveGradeSubAct">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate,
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="12">
          <el-radio-group v-model="radio" @change="radioChange">
            <el-radio label="按年级">按年级</el-radio>
            <el-radio label="按学科">按学科</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          {{ radio == "按年级" ? "年级活跃" : "学科活跃" }}
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="radio == '按年级' ? NJHY : XKHY"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="center">
          <el-select
            v-model="selectValue"
            placeholder="请选择学校"
            @change="selectChange"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.label"
              :value="{ value: item.value, label: item.label }"
            >
            </el-option>
          </el-select>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="goGradeSubDetail"
            >教师明细</el-button
          >
          <el-button type="primary" size="small" @click="downExcel">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          :key="'allActiveGradeSubAct'+keyTable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="radio=='按年级'?{ prop: 'gradeName', order: 'ascending' }:{ prop: 'activeTeaNum', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{
                (searchForm.pageNum - 1) * searchForm.pageSize +
                scope.$index +
                1
              }}</span>
            </template>
          </el-table-column>
          <template v-if="radio == '按年级'">
            <el-table-column
              v-for="(item, index) in tableGrade"
              :key="index"
              :fixed="item.fixed"
              :label="item.label"
              :width="item.width"
              :prop="item.prop"
              :sortable="item.sort"
            >
            </el-table-column>
          </template>
          <template v-if="radio == '按学科'">
            <el-table-column
              v-for="(item, index) in tableSubject"
              :key="index"
              :fixed="item.fixed"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sort"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from "../../components/datePicker/index.vue";
import { isBack } from "@/mixins/isBack.js";
import { lastWeek } from "@/utils/date.js";
import { NJHY, XKHY } from "@/utils/explainText.js";
import { saveAs } from "file-saver";
import {
  gradeList,
  subjectList,
} from "@/api/modules/excelApi.js";
import { generateTableParms, getToken, excelName } from "@/utils/index.js";
export default {
  name: "AllActiveGradeSubAct",
  mixins: [isBack],
  components: { datePicker },
  data() {
    return {
      NJHY: NJHY,
      XKHY: XKHY,
      searchForm: {
        loginUserId: JSON.parse(sessionStorage.getItem("userInfo")).Key,
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        pageSize: 12,
        pageNum: 1,
        schoolId: undefined,
        sortCode: "gradeName",
        ascOrDes: true, //false是降序,true是升序
      },
      total: 0,
      radio: "按年级",
      selectValue: {},
      schoolList: JSON.parse(sessionStorage.getItem("schoolList")),
      tableData: [],
      keyTable: 19,
      loading: false,
      tableGrade: [
        {
          prop: "gradeName",
          label: "年级",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "activeTeaNum",
          label: "活跃教师数",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "activeTeaPent",
          label: "教师活跃率",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "functionUse",
          label: "功能使用度",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "lesson",
          label: "备课",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "classLesson",
          label: "上课",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "tasks",
          label: "作业",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "aiCard",
          label: "智能卡",
          sort: "custom",
          fixed: false,
          width: "",
        },
      ],
      tableSubject: [
        {
          prop: "subjectName",
          label: "学科",
          sort: false,
          fixed: false,
          width: "",
        },
        {
          prop: "activeTeaNum",
          label: "活跃教师数",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "activeTeaPent",
          label: "教师活跃率",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "functionUse",
          label: "功能使用度",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "lesson",
          label: "备课",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "classLesson",
          label: "上课",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "tasks",
          label: "作业",
          sort: "custom",
          fixed: false,
          width: "",
        },
        {
          prop: "aiCard",
          label: "智能卡",
          sort: "custom",
          fixed: false,
          width: "",
        },
      ],
    };
  },
  created() {
    this.init();
    this.getGradeAct();
  },
  methods: {
    init() {
      let info = JSON.parse(this.$route.query.info);
      this.searchForm.startDate = info.startDate;
      this.searchForm.endDate = info.endDate;
      this.selectValue.value = info.schoolId;
      this.selectValue.label = info.schoolName;
      this.searchForm.schoolId = this.selectValue.value;
    },
    radioChange() {
      if (this.radio=='按年级') {
        this.searchForm.sortCode = 'gradeName'
        this.searchForm.ascOrDes = true
      }else{
        this.searchForm.sortCode = 'activeTeaNum'
        this.searchForm.ascOrDes = false
      }
      this.searchForm.pageNum =1
      this.keyTable++;
      this.axiosIf()
    },
    search() {
      this.searchForm.pageNum =1
      this.axiosIf()
    },
    reset() {
       let info = JSON.parse(this.$route.query.info);
      this.searchForm.startDate = info.startDate;
      this.searchForm.endDate = info.endDate;
      this.searchForm.schoolId = this.selectValue.value;
      this.searchForm.pageNum =1
      if (this.radio == '按年级') {
        this.searchForm.sortCode = 'gradeName'
        this.searchForm.ascOrDes = true
      }else{
        this.searchForm.sortCode = 'activeTeaNum'
        this.searchForm.ascOrDes = false
      }
      this.keyTable++;
      this.axiosIf()
    },
    selectChange(v) {
      this.searchForm.pageNum = 1
      this.searchForm.schoolId = this.selectValue.value;
      this.axiosIf()
    },
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop;
      if (order !== null) {
        order == "descending"
          ? (this.searchForm.ascOrDes = false)
          : (this.searchForm.ascOrDes = true);
        this.axiosIf();
      }
    },
    handleCurrentChange(v) {
      this.searchForm.pageNum = v;
     this.axiosIf();
    },
    goGradeSubDetail() {
      let obj = {
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        ...this.selectValue
      }
      this.$router.push({
        name: "AllActiveGradeSubDetail",
        query: {
          info: JSON.stringify(obj),
        },
      });
    },
    // 请求接口判断
    axiosIf(){
      if (this.radio == "按年级") {
        this.getGradeAct();
      } else {
        this.getSubjectAct();
      }
    },
    // 导出表格
    downExcel(){
      let obj = {
        fileName: "",
        ...this.searchForm,
        ...getToken(),
      };
      delete obj.pageSize;
      delete obj.pageNum;
      if (this.radio == "按年级") {
        obj.fileName = excelName("学校年级教师活跃分析", obj.startDate, obj.endDate);
        saveAs(
          gradeList + generateTableParms(obj),
          obj.fileName + ".xlsx"
        );
      } else {
        obj.fileName = excelName(
          "学校学科教师活跃分析",
          obj.startDate,
          obj.endDate
        );
        saveAs(
          subjectList + generateTableParms(obj),
          obj.fileName + ".xlsx"
        );
      }
    },
    // 获取年级活跃
    getGradeAct() {
      this.loading = true;
      this.$API.allActiveSchApi
        .getGradeAct(this.searchForm)
        .then((res) => {
          this.tableData = res.result;
          if (this.tableData.length > 0) {
            this.total = this.tableData[0].total;
            this.tableData.forEach((el) => {
              el.activeTeaPent = el.activeTeaPent + "%";
            });
          } else {
            this.total = 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取学科活跃
    getSubjectAct() {
      this.loading = true;
      this.$API.allActiveSchApi
        .getSubjectAct(this.searchForm)
        .then((res) => {
          this.tableData = res.result;
          if (this.tableData.length > 0) {
            this.total = this.tableData[0].total;
            this.tableData.forEach((el) => {
              el.activeTeaPent = el.activeTeaPent + "%";
            });
          } else {
            this.total = 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.allActiveGradeSubAct {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
